var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _rect, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 376,
    viewBox: "0 0 717 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717 0H0V375.23H717V0Z",
    fill: "#B4E8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M574.317 222.568C577.902 213.904 579.874 204.404 579.874 194.426C579.874 158.516 554.241 128.581 520.244 122.009C520.184 90.4606 494.551 64.8876 463.003 64.8876C452.547 64.8876 442.808 67.6958 434.383 72.5356C411.08 58.4346 383.715 50.3086 354.437 50.3086C282.678 50.3086 222.33 99.1841 204.883 165.447C121.711 168.016 55.0898 236.251 55.0898 320.02C55.0898 339.499 58.6748 358.081 65.2473 375.229H656.414C659.999 363.757 661.971 351.568 661.971 338.901C661.911 283.692 624.926 237.087 574.317 222.568Z",
    fill: "#5BC5DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525.441 333.525H191.558C185.404 333.525 180.385 328.506 180.385 322.352C180.385 316.198 185.404 311.179 191.558 311.179H525.381C531.536 311.179 536.555 316.198 536.555 322.352C536.614 328.566 531.595 333.525 525.441 333.525Z",
    fill: "#1698B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.309 124.694H146.077V322.779H149.309V124.694Z",
    fill: "#055C7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.664 124.693H256.432V322.778H259.664V124.693Z",
    fill: "#055C7F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.279 133.467H146.077V136.699H258.279V133.467Z",
    fill: "#055C7F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.279 177.331H146.077V180.563H258.279V177.331Z",
    fill: "#055C7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258.279 221.197H146.077V224.429H258.279V221.197Z",
    fill: "#055C7F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.279 265.061H146.077V268.293H258.279V265.061Z",
    fill: "#055C7F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.279 308.927H146.077V312.159H258.279V308.927Z",
    fill: "#055C7F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M147.694 128.388C149.734 128.388 151.388 126.734 151.388 124.694C151.388 122.654 149.734 121 147.694 121C145.654 121 144 122.654 144 124.694C144 126.734 145.654 128.388 147.694 128.388Z",
    fill: "#055C7F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.048 128.388C260.088 128.388 261.742 126.734 261.742 124.694C261.742 122.654 260.088 121 258.048 121C256.008 121 254.354 122.654 254.354 124.694C254.354 126.734 256.008 128.388 258.048 128.388Z",
    fill: "#055C7F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.238 143.164H149.31V177.333H162.238V143.164Z",
    fill: "#39AECB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.238 151.477H149.31V162.096H162.238V151.477Z",
    fill: "#84DAED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.238 146.859H149.31V149.168H162.238V146.859Z",
    fill: "#84DAED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.017 146.857H175.167V177.332H183.017V146.857Z",
    fill: "#39AECB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.017 154.29H175.167V163.756H183.017V154.29Z",
    fill: "#84DAED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.017 150.135H175.167V152.213H183.017V150.135Z",
    fill: "#84DAED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.017 171.375H175.167V173.453H183.017V171.375Z",
    fill: "#84DAED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190.865 146.857H183.016V177.332H190.865V146.857Z",
    fill: "#1698B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M190.865 154.29H183.016V163.756H190.865V154.29Z",
    fill: "#39AECB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.865 150.135H183.016V152.213H190.865V150.135Z",
    fill: "#39AECB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.865 171.375H183.016V173.453H190.865V171.375Z",
    fill: "#39AECB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.944 139.47H190.865V177.332H195.944V139.47Z",
    fill: "#39AECB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.56 143.164H192.251V172.253H194.56V143.164Z",
    fill: "#84DAED"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.824 139.323L200.831 140.251L207.752 177.473L212.746 176.545L205.824 139.323Z",
    fill: "#39AECB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M205.123 143.2L202.854 143.622L208.171 172.22L210.441 171.798L205.123 143.2Z",
    fill: "#84DAED"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.023 139.47H195.944V177.332H201.023V139.47Z",
    fill: "#1698B8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M199.639 143.164H197.33V172.253H199.639V143.164Z",
    fill: "#39AECB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.436 140.191L251.435 139.311L244.869 176.597L249.871 177.478L256.436 140.191Z",
    fill: "#1698B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M254.47 143.59L252.196 143.189L247.152 171.84L249.426 172.24L254.47 143.59Z",
    fill: "#39AECB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M157.159 234.587H149.31V265.062H157.159V234.587Z",
    fill: "#39AECB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M157.159 242.02H149.31V251.485H157.159V242.02Z",
    fill: "#84DAED"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.159 237.864H149.31V239.942H157.159V237.864Z",
    fill: "#84DAED"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M157.159 259.104H149.31V261.182H157.159V259.104Z",
    fill: "#84DAED"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.009 234.587H157.159V265.062H165.009V234.587Z",
    fill: "#1698B8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M165.009 242.02H157.159V251.485H165.009V242.02Z",
    fill: "#39AECB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M165.009 237.864H157.159V239.942H165.009V237.864Z",
    fill: "#39AECB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M165.009 259.104H157.159V261.182H165.009V259.104Z",
    fill: "#39AECB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M170.088 227.199H165.009V265.062H170.088V227.199Z",
    fill: "#39AECB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M168.703 230.893H166.395V259.982H168.703V230.893Z",
    fill: "#84DAED"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M186.841 233.868L183.155 237.362L209.205 264.839L212.89 261.345L186.841 233.868Z",
    fill: "#39AECB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M188.384 237.484L186.709 239.072L206.722 260.182L208.398 258.594L188.384 237.484Z",
    fill: "#84DAED"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M193.766 233.868L190.08 237.362L216.129 264.839L219.815 261.345L193.766 233.868Z",
    fill: "#1698B8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M195.309 237.484L193.634 239.072L213.647 260.182L215.323 258.594L195.309 237.484Z",
    fill: "#84DAED"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M175.166 227.199H170.087V265.062H175.166V227.199Z",
    fill: "#1698B8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.781 230.893H171.473V259.982H173.781V230.893Z",
    fill: "#39AECB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M179.682 228.145L174.994 230.101L189.571 265.044L194.259 263.088L179.682 228.145Z",
    fill: "#1698B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M179.813 232.087L177.683 232.976L188.882 259.822L191.013 258.933L179.813 232.087Z",
    fill: "#39AECB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M175.167 143.162H162.238V177.331H175.167V143.162Z",
    fill: "#1698B8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.167 151.475H162.238V162.095H175.167V151.475Z",
    fill: "#39AECB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M175.167 146.857H162.238V149.166H175.167V146.857Z",
    fill: "#39AECB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M204.718 190.723H196.868V221.197H204.718V190.723Z",
    fill: "#39AECB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M204.718 198.157H196.868V207.623H204.718V198.157Z",
    fill: "#84DAED"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M204.718 194.001H196.868V196.079H204.718V194.001Z",
    fill: "#84DAED"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M204.718 215.241H196.868V217.319H204.718V215.241Z",
    fill: "#84DAED"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M212.619 190.527L204.782 190.976L206.526 221.401L214.363 220.952L212.619 190.527Z",
    fill: "#1698B8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M213.036 197.945L205.199 198.394L205.741 207.844L213.578 207.395L213.036 197.945Z",
    fill: "#39AECB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M212.786 193.829L204.949 194.278L205.068 196.353L212.905 195.904L212.786 193.829Z",
    fill: "#39AECB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M214.032 215.023L206.195 215.472L206.314 217.546L214.151 217.097L214.032 215.023Z",
    fill: "#39AECB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M196.869 187.027H183.94V221.196H196.869V187.027Z",
    fill: "#1698B8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M196.869 195.339H183.94V205.959H196.869V195.339Z",
    fill: "#39AECB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M196.869 190.721H183.94V193.029H196.869V190.721Z",
    fill: "#39AECB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M212.105 303.755C212.197 305.233 211.643 306.572 210.674 307.496C209.796 308.373 208.596 308.927 207.257 308.927H181.4C181.03 308.927 180.707 308.604 180.707 308.234C180.707 307.865 181.03 307.542 181.4 307.542H203.886C205.641 307.542 207.211 306.295 207.442 304.54C207.719 302.416 206.056 300.616 204.025 300.616H181.4C181.03 300.616 180.707 300.292 180.707 299.923C180.707 299.554 181.03 299.23 181.4 299.23H207.118C209.658 299.23 211.92 301.17 212.105 303.755Z",
    fill: "#F87895"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M182.092 307.542V300.616H207.256C209.15 300.616 210.719 302.186 210.719 304.079C210.719 305.972 209.15 307.542 207.256 307.542H182.092Z",
    fill: "#FEF6F4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M183.941 294.706C183.848 293.228 184.402 291.889 185.372 290.966C186.249 290.088 187.45 289.534 188.789 289.534H214.646C215.015 289.534 215.339 289.857 215.339 290.227C215.339 290.596 215.015 290.919 214.646 290.919H192.16C190.405 290.919 188.835 292.166 188.604 293.921C188.327 296.045 189.989 297.845 192.021 297.845H214.646C215.015 297.845 215.339 298.169 215.339 298.538C215.339 298.907 215.015 299.231 214.646 299.231H188.927C186.388 299.231 184.125 297.291 183.941 294.706Z",
    fill: "#FD9CAE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M213.954 290.92V297.846H188.789C186.896 297.846 185.326 296.276 185.326 294.383C185.326 292.49 186.896 290.92 188.789 290.92H213.954Z",
    fill: "#FEF6F4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M214.414 284.362C214.506 285.839 213.952 287.179 212.982 288.102C212.105 288.979 210.904 289.533 209.565 289.533H183.708C183.339 289.533 183.016 289.21 183.016 288.841C183.016 288.471 183.339 288.148 183.708 288.148H206.195C207.949 288.148 209.519 286.901 209.75 285.147C210.027 283.023 208.365 281.222 206.333 281.222H183.708C183.339 281.222 183.016 280.899 183.016 280.53C183.016 280.16 183.339 279.837 183.708 279.837H209.427C211.966 279.837 214.229 281.776 214.414 284.362Z",
    fill: "#EC577F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M184.401 288.148V281.222H209.566C211.459 281.222 213.029 282.792 213.029 284.685C213.029 286.578 211.459 288.148 209.566 288.148H184.401Z",
    fill: "#FEF6F4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M246.274 216.026C246.366 217.504 245.812 218.843 244.843 219.766C243.965 220.643 242.765 221.197 241.426 221.197H215.569C215.199 221.197 214.876 220.874 214.876 220.505C214.876 220.135 215.199 219.812 215.569 219.812H238.055C239.81 219.812 241.38 218.566 241.611 216.811C241.888 214.687 240.225 212.886 238.194 212.886H215.569C215.199 212.886 214.876 212.563 214.876 212.194C214.876 211.824 215.199 211.501 215.569 211.501H241.287C243.827 211.501 246.089 213.44 246.274 216.026Z",
    fill: "#F87895"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M216.262 219.812V212.886H241.426C243.319 212.886 244.889 214.456 244.889 216.349C244.889 218.242 243.319 219.812 241.426 219.812H216.262Z",
    fill: "#FEF6F4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M218.109 206.974C218.016 205.497 218.57 204.158 219.54 203.234C220.417 202.357 221.618 201.803 222.957 201.803H248.814C249.183 201.803 249.507 202.126 249.507 202.495C249.507 202.865 249.183 203.188 248.814 203.188H226.328C224.573 203.188 223.003 204.435 222.772 206.189C222.495 208.313 224.157 210.114 226.189 210.114H248.814C249.183 210.114 249.507 210.437 249.507 210.807C249.507 211.176 249.183 211.499 248.814 211.499H223.095C220.556 211.499 218.293 209.56 218.109 206.974Z",
    fill: "#FD9CAE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M248.122 203.188V210.115H222.957C221.064 210.115 219.494 208.545 219.494 206.651C219.494 204.758 221.064 203.188 222.957 203.188H248.122Z",
    fill: "#FEF6F4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M248.584 196.631C248.676 198.109 248.122 199.448 247.152 200.372C246.275 201.249 245.074 201.803 243.735 201.803H217.878C217.509 201.803 217.186 201.48 217.186 201.11C217.186 200.741 217.509 200.418 217.878 200.418H240.365C242.119 200.418 243.689 199.171 243.92 197.416C244.197 195.292 242.535 193.492 240.503 193.492H217.878C217.509 193.492 217.186 193.168 217.186 192.799C217.186 192.43 217.509 192.106 217.878 192.106H243.597C246.136 192.106 248.399 194.046 248.584 196.631Z",
    fill: "#EC577F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M218.571 200.417V193.491H243.736C245.629 193.491 247.199 195.061 247.199 196.954C247.199 198.847 245.629 200.417 243.736 200.417H218.571Z",
    fill: "#FEF6F4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M151.157 216.672C151.065 215.195 151.619 213.856 152.589 212.932C153.466 212.055 154.667 211.501 156.006 211.501H181.863C182.232 211.501 182.556 211.824 182.556 212.194C182.556 212.563 182.232 212.886 181.863 212.886H159.376C157.622 212.886 156.052 214.133 155.821 215.887C155.544 218.011 157.206 219.812 159.238 219.812H181.863C182.232 219.812 182.556 220.135 182.556 220.505C182.556 220.874 182.232 221.197 181.863 221.197H156.144C153.605 221.197 151.342 219.258 151.157 216.672Z",
    fill: "#FD9CAE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M181.171 212.886V219.812H156.006C154.113 219.812 152.543 218.242 152.543 216.349C152.543 214.456 154.113 212.886 156.006 212.886H181.171Z",
    fill: "#FEF6F4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M181.631 206.328C181.724 207.805 181.17 209.144 180.2 210.068C179.323 210.945 178.122 211.499 176.783 211.499H150.926C150.557 211.499 150.233 211.176 150.233 210.807C150.233 210.437 150.557 210.114 150.926 210.114H173.413C175.167 210.114 176.737 208.867 176.968 207.113C177.245 204.989 175.583 203.188 173.551 203.188H150.926C150.557 203.188 150.233 202.865 150.233 202.495C150.233 202.126 150.557 201.803 150.926 201.803H176.645C179.184 201.803 181.447 203.742 181.631 206.328Z",
    fill: "#EC577F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M151.619 210.115V203.188H176.784C178.677 203.188 180.247 204.758 180.247 206.651C180.247 208.545 178.677 210.115 176.784 210.115H151.619Z",
    fill: "#FEF6F4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M177.061 308.927H151.619V274.297H177.061C178.03 274.297 178.862 275.082 178.862 276.098V307.126C178.862 308.142 178.077 308.927 177.061 308.927Z",
    fill: "#39AECB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M155.313 274.296H154.39V308.926H155.313V274.296Z",
    fill: "#1698B8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M240.318 177.331H214.876V142.701H240.318C241.287 142.701 242.118 143.486 242.118 144.502V175.531C242.118 176.546 241.333 177.331 240.318 177.331Z",
    fill: "#39AECB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M218.57 142.702H217.646V177.332H218.57V142.702Z",
    fill: "#1698B8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M572.81 322.778H576.042V124.693H572.81V322.778Z",
    fill: "#055C7F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M462.455 322.778H465.688V124.693H462.455V322.778Z",
    fill: "#055C7F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M463.84 136.698H576.042V133.466H463.84V136.698Z",
    fill: "#055C7F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M463.84 180.564H576.042V177.332H463.84V180.564Z",
    fill: "#055C7F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M463.84 224.428H576.042V221.196H463.84V224.428Z",
    fill: "#055C7F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M463.84 268.293H576.042V265.061H463.84V268.293Z",
    fill: "#055C7F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M463.84 312.158H576.042V308.926H463.84V312.158Z",
    fill: "#055C7F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M574.426 128.388C576.466 128.388 578.12 126.734 578.12 124.694C578.12 122.654 576.466 121 574.426 121C572.386 121 570.732 122.654 570.732 124.694C570.732 126.734 572.386 128.388 574.426 128.388Z",
    fill: "#055C7F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M464.072 128.388C466.112 128.388 467.766 126.734 467.766 124.694C467.766 122.654 466.112 121 464.072 121C462.032 121 460.378 122.654 460.378 124.694C460.378 126.734 462.032 128.388 464.072 128.388Z",
    fill: "#055C7F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M567.642 183.894L562.616 183.161L557.156 220.626L562.182 221.358L567.642 183.894Z",
    fill: "#39AECB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M565.732 187.342L563.447 187.009L559.253 215.793L561.537 216.126L565.732 187.342Z",
    fill: "#84DAED"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M562.564 183.894L557.538 183.161L552.078 220.626L557.104 221.358L562.564 183.894Z",
    fill: "#1698B8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M560.654 187.342L558.369 187.009L554.174 215.793L556.459 216.126L560.654 187.342Z",
    fill: "#84DAED"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M572.812 183.334H567.732V221.196H572.812V183.334Z",
    fill: "#1698B8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M571.426 187.029H569.117V216.119H571.426V187.029Z",
    fill: "#39AECB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M569.093 227.04L564.038 227.535L567.732 265.216L572.787 264.72L569.093 227.04Z",
    fill: "#1698B8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M568.095 230.845L565.798 231.07L568.636 260.02L570.934 259.795L568.095 230.845Z",
    fill: "#39AECB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M498.472 278.452H490.622V308.927H498.472V278.452Z",
    fill: "#39AECB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M498.472 285.885H490.622V295.35H498.472V285.885Z",
    fill: "#84DAED"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M498.472 281.73H490.622V283.808H498.472V281.73Z",
    fill: "#84DAED"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M498.472 302.97H490.622V305.048H498.472V302.97Z",
    fill: "#84DAED"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M506.321 278.452H498.472V308.927H506.321V278.452Z",
    fill: "#1698B8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M506.321 285.885H498.472V295.35H506.321V285.885Z",
    fill: "#39AECB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M506.321 281.73H498.472V283.808H506.321V281.73Z",
    fill: "#39AECB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M506.321 302.97H498.472V305.048H506.321V302.97Z",
    fill: "#39AECB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M490.622 278.452H482.772V308.927H490.622V278.452Z",
    fill: "#1698B8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M490.622 285.885H482.772V295.35H490.622V285.885Z",
    fill: "#39AECB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M490.622 281.73H482.772V283.808H490.622V281.73Z",
    fill: "#39AECB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M490.622 302.97H482.772V305.048H490.622V302.97Z",
    fill: "#39AECB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M572.81 278.452H564.961V308.927H572.81V278.452Z",
    fill: "#39AECB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M572.81 285.885H564.961V295.35H572.81V285.885Z",
    fill: "#84DAED"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M572.81 281.73H564.961V283.808H572.81V281.73Z",
    fill: "#84DAED"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M572.81 302.97H564.961V305.048H572.81V302.97Z",
    fill: "#84DAED"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M511.4 271.064H506.321V308.927H511.4V271.064Z",
    fill: "#39AECB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M510.015 274.759H507.706V303.848H510.015V274.759Z",
    fill: "#84DAED"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M528.144 277.726L524.458 281.221L550.507 308.697L554.193 305.203L528.144 277.726Z",
    fill: "#39AECB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M529.684 281.337L528.009 282.926L548.022 304.036L549.698 302.448L529.684 281.337Z",
    fill: "#84DAED"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M535.07 277.726L531.384 281.221L557.433 308.697L561.119 305.203L535.07 277.726Z",
    fill: "#1698B8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M536.61 281.337L534.935 282.926L554.948 304.036L556.623 302.448L536.61 281.337Z",
    fill: "#84DAED"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M516.479 271.064H511.4V308.927H516.479V271.064Z",
    fill: "#1698B8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M515.095 274.759H512.786V303.848H515.095V274.759Z",
    fill: "#39AECB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M520.992 272.022L516.305 273.978L530.882 308.921L535.569 306.965L520.992 272.022Z",
    fill: "#1698B8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M521.124 275.965L518.993 276.854L530.193 303.7L532.323 302.811L521.124 275.965Z",
    fill: "#39AECB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M504.475 143.162H491.546V177.331H504.475V143.162Z",
    fill: "#39AECB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M504.475 151.475H491.546V162.095H504.475V151.475Z",
    fill: "#84DAED"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M504.475 146.857H491.546V149.166H504.475V146.857Z",
    fill: "#84DAED"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M525.253 146.857H517.403V177.332H525.253V146.857Z",
    fill: "#39AECB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M525.253 154.29H517.403V163.756H525.253V154.29Z",
    fill: "#84DAED"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M525.253 150.135H517.403V152.213H525.253V150.135Z",
    fill: "#84DAED"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M525.253 171.375H517.403V173.453H525.253V171.375Z",
    fill: "#84DAED"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M533.101 146.857H525.252V177.332H533.101V146.857Z",
    fill: "#1698B8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M533.101 154.29H525.252V163.756H533.101V154.29Z",
    fill: "#39AECB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M533.101 150.135H525.252V152.213H533.101V150.135Z",
    fill: "#39AECB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M533.101 171.375H525.252V173.453H533.101V171.375Z",
    fill: "#39AECB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M538.182 139.47H533.103V177.332H538.182V139.47Z",
    fill: "#39AECB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M536.796 143.164H534.487V172.253H536.796V143.164Z",
    fill: "#84DAED"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M548.045 139.326L543.052 140.255L549.973 177.477L554.966 176.549L548.045 139.326Z",
    fill: "#39AECB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M547.344 143.205L545.074 143.627L550.392 172.225L552.661 171.803L547.344 143.205Z",
    fill: "#84DAED"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M543.261 139.47H538.182V177.332H543.261V139.47Z",
    fill: "#1698B8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M541.875 143.164H539.566V172.253H541.875V143.164Z",
    fill: "#39AECB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M562.653 146.857H554.804V177.332H562.653V146.857Z",
    fill: "#1698B8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M562.653 154.29H554.804V163.756H562.653V154.29Z",
    fill: "#39AECB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M562.653 150.135H554.804V152.213H562.653V150.135Z",
    fill: "#39AECB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M562.653 171.375H554.804V173.453H562.653V171.375Z",
    fill: "#39AECB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M567.731 139.47H562.652V177.332H567.731V139.47Z",
    fill: "#39AECB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M566.347 143.164H564.038V172.253H566.347V143.164Z",
    fill: "#84DAED"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M572.811 139.47H567.731V177.332H572.811V139.47Z",
    fill: "#1698B8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M571.425 143.164H569.116V172.253H571.425V143.164Z",
    fill: "#39AECB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M491.545 139.47H486.466V177.332H491.545V139.47Z",
    fill: "#1698B8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M490.16 143.164H487.852V172.253H490.16V143.164Z",
    fill: "#39AECB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M517.403 143.162H504.475V177.331H517.403V143.162Z",
    fill: "#1698B8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M517.403 151.475H504.475V162.095H517.403V151.475Z",
    fill: "#39AECB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M517.403 146.857H504.475V149.166H517.403V146.857Z",
    fill: "#39AECB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M548.801 216.026C548.894 217.504 548.34 218.843 547.37 219.766C546.493 220.643 545.292 221.197 543.953 221.197H518.096C517.727 221.197 517.403 220.874 517.403 220.505C517.403 220.135 517.727 219.812 518.096 219.812H540.582C542.337 219.812 543.907 218.566 544.138 216.811C544.415 214.687 542.753 212.886 540.721 212.886H518.096C517.727 212.886 517.403 212.563 517.403 212.194C517.403 211.824 517.727 211.501 518.096 211.501H543.815C546.354 211.501 548.617 213.44 548.801 216.026Z",
    fill: "#F87895"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M518.789 219.812V212.886H543.954C545.847 212.886 547.417 214.456 547.417 216.349C547.417 218.242 545.847 219.812 543.954 219.812H518.789Z",
    fill: "#FEF6F4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M520.635 206.974C520.543 205.497 521.097 204.158 522.066 203.234C522.944 202.357 524.144 201.803 525.483 201.803H551.34C551.71 201.803 552.033 202.126 552.033 202.495C552.033 202.865 551.71 203.188 551.34 203.188H528.854C527.099 203.188 525.529 204.435 525.299 206.189C525.021 208.313 526.684 210.114 528.715 210.114H551.34C551.71 210.114 552.033 210.437 552.033 210.807C552.033 211.176 551.71 211.499 551.34 211.499H525.622C523.082 211.499 520.82 209.56 520.635 206.974Z",
    fill: "#FD9CAE"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M550.648 203.188V210.115H525.484C523.59 210.115 522.021 208.545 522.021 206.651C522.021 204.758 523.59 203.188 525.484 203.188H550.648Z",
    fill: "#FEF6F4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M551.11 196.631C551.202 198.109 550.648 199.448 549.679 200.372C548.801 201.249 547.601 201.803 546.262 201.803H520.405C520.035 201.803 519.712 201.48 519.712 201.11C519.712 200.741 520.035 200.418 520.405 200.418H542.891C544.646 200.418 546.216 199.171 546.446 197.416C546.723 195.292 545.061 193.492 543.03 193.492H520.405C520.035 193.492 519.712 193.168 519.712 192.799C519.712 192.43 520.035 192.106 520.405 192.106H546.123C548.663 192.106 550.925 194.046 551.11 196.631Z",
    fill: "#EC577F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M521.098 200.417V193.491H546.262C548.155 193.491 549.725 195.061 549.725 196.954C549.725 198.847 548.155 200.417 546.262 200.417H521.098Z",
    fill: "#FEF6F4"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M518.79 259.89C518.882 261.368 518.328 262.707 517.358 263.63C516.481 264.508 515.28 265.062 513.941 265.062H488.084C487.715 265.062 487.392 264.738 487.392 264.369C487.392 264 487.715 263.676 488.084 263.676H510.571C512.325 263.676 513.895 262.43 514.126 260.675C514.403 258.551 512.741 256.75 510.709 256.75H488.084C487.715 256.75 487.392 256.427 487.392 256.058C487.392 255.688 487.715 255.365 488.084 255.365H513.803C516.342 255.365 518.605 257.305 518.79 259.89Z",
    fill: "#F87895"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M488.777 263.676V256.75H513.942C515.835 256.75 517.405 258.32 517.405 260.213C517.405 262.106 515.835 263.676 513.942 263.676H488.777Z",
    fill: "#FEF6F4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M533.426 234.08C534.857 234.449 535.965 235.373 536.566 236.573C537.12 237.681 537.258 238.974 536.889 240.267L528.947 264.924C528.808 265.293 528.439 265.478 528.07 265.386C527.7 265.247 527.516 264.878 527.608 264.508L534.534 243.084C535.088 241.422 534.349 239.528 532.779 238.79C530.84 237.866 528.624 238.882 527.977 240.867L521.005 262.384C520.867 262.754 520.497 262.938 520.128 262.846C519.758 262.708 519.574 262.338 519.666 261.969L527.562 237.497C528.393 235.003 530.932 233.48 533.426 234.08Z",
    fill: "#FD9CAE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M527.838 263.814L521.235 261.69L528.946 237.726C529.547 235.925 531.486 234.91 533.287 235.51C535.087 236.11 536.103 238.049 535.503 239.85L527.838 263.814Z",
    fill: "#FEF6F4"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M482.634 145.889C484.065 146.258 485.173 147.181 485.774 148.382C486.328 149.49 486.466 150.783 486.097 152.076L478.155 176.732C478.016 177.102 477.647 177.287 477.278 177.194C476.908 177.056 476.724 176.686 476.816 176.317L483.742 154.892C484.296 153.23 483.557 151.337 481.987 150.598C480.048 149.675 477.832 150.691 477.185 152.676L470.213 174.193C470.075 174.562 469.705 174.747 469.336 174.655C468.966 174.516 468.782 174.147 468.874 173.777L476.77 149.305C477.601 146.812 480.14 145.288 482.634 145.889Z",
    fill: "#FD9CAE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M477.047 175.623L470.444 173.499L478.155 149.535C478.756 147.734 480.695 146.718 482.496 147.318C484.296 147.919 485.312 149.858 484.712 151.659L477.047 175.623Z",
    fill: "#FEF6F4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M490.623 250.84C490.531 249.363 491.085 248.024 492.055 247.1C492.932 246.223 494.132 245.669 495.471 245.669H521.329C521.698 245.669 522.021 245.992 522.021 246.362C522.021 246.731 521.698 247.054 521.329 247.054H498.842C497.088 247.054 495.518 248.301 495.287 250.055C495.01 252.179 496.672 253.98 498.704 253.98H521.329C521.698 253.98 522.021 254.303 522.021 254.673C522.021 255.042 521.698 255.365 521.329 255.365H495.61C493.07 255.365 490.808 253.426 490.623 250.84Z",
    fill: "#FD9CAE"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M520.636 247.054V253.98H495.472C493.579 253.98 492.009 252.41 492.009 250.517C492.009 248.624 493.579 247.054 495.472 247.054H520.636Z",
    fill: "#FEF6F4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M521.096 240.498C521.189 241.975 520.635 243.314 519.665 244.238C518.788 245.115 517.587 245.669 516.248 245.669H490.391C490.021 245.669 489.698 245.346 489.698 244.977C489.698 244.607 490.021 244.284 490.391 244.284H512.877C514.632 244.284 516.202 243.037 516.433 241.283C516.71 239.159 515.048 237.358 513.016 237.358H490.391C490.021 237.358 489.698 237.035 489.698 236.665C489.698 236.296 490.021 235.973 490.391 235.973H516.11C518.649 235.973 520.912 237.912 521.096 240.498Z",
    fill: "#EC577F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M491.084 244.284V237.358H516.249C518.142 237.358 519.712 238.928 519.712 240.821C519.712 242.715 518.142 244.284 516.249 244.284H491.084Z",
    fill: "#FEF6F4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M562.7 265.061H537.259V230.431H562.7C563.67 230.431 564.501 231.216 564.501 232.231V263.26C564.501 264.276 563.716 265.061 562.7 265.061Z",
    fill: "#39AECB"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M540.952 230.432H540.028V265.062H540.952V230.432Z",
    fill: "#1698B8"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M514.678 221.197H489.236V186.566H514.678C515.648 186.566 516.479 187.351 516.479 188.367V219.396C516.479 220.412 515.694 221.197 514.678 221.197Z",
    fill: "#39AECB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M492.93 186.566H492.007V221.197H492.93V186.566Z",
    fill: "#1698B8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M69.31 50.8467C47.8 50.8467 29.636 65.3062 24.0195 85.0237H114.66C108.984 65.2464 90.82 50.8467 69.31 50.8467Z",
    fill: "#FEF6F4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M192.933 50.8467C171.423 50.8467 153.259 65.3062 147.643 85.0237H238.283C232.607 65.2464 214.503 50.8467 192.933 50.8467Z",
    fill: "#FEF6F4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M134.02 36.208C103.249 36.208 77.317 56.8218 69.3105 85.0238H198.789C190.723 56.8218 164.791 36.208 134.02 36.208Z",
    fill: "#FEF6F4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5999 80.124C63.2756 80.124 52.1024 89.0268 48.5771 101.216H104.563C101.097 89.0268 89.8644 80.124 76.5999 80.124Z",
    fill: "#DBF0F7"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M152.96 80.124C139.636 80.124 128.463 89.0268 124.938 101.216H180.923C177.458 89.0268 166.225 80.124 152.96 80.124Z",
    fill: "#DBF0F7"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M116.572 71.043C97.5719 71.043 81.5589 83.7697 76.5996 101.217H156.545C151.586 83.7697 135.573 71.043 116.572 71.043Z",
    fill: "#DBF0F7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M538.646 114.182C520.96 114.182 506.023 126.072 501.362 142.264H575.871C571.33 126.012 556.392 114.182 538.646 114.182Z",
    fill: "#DBF0F7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M640.341 114.182C622.655 114.182 607.717 126.072 603.057 142.264H677.565C672.964 126.012 658.027 114.182 640.341 114.182Z",
    fill: "#DBF0F7"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M591.884 102.112C566.609 102.112 545.279 119.081 538.646 142.264H645.121C638.489 119.081 617.158 102.112 591.884 102.112Z",
    fill: "#DBF0F7"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M332.807 295.463L331.254 316.256H385.746L384.192 295.463H332.807Z",
    fill: "#EBECEC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M383.296 284.11H333.704L332.808 295.463H384.193L383.296 284.11Z",
    fill: "#CACDCD"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M399.489 323.366H317.512V319.064C317.512 316.495 319.603 314.403 322.172 314.403H394.768C397.338 314.403 399.429 316.495 399.429 319.064V323.366H399.489Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M479.075 113.226H237.924C233.861 113.226 230.575 116.512 230.575 120.575V265.349H382.34H486.484V161.265V120.635C486.425 116.512 483.138 113.226 479.075 113.226Z",
    fill: "#00365D"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M382.281 265.349H230.516V282.796C230.516 286.859 233.802 290.145 237.865 290.145H357.425H479.016C483.079 290.145 486.365 286.859 486.365 282.796V265.349H382.281Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M357.664 122.188H328.984H239.538V211.634V255.192H357.664H475.849V122.188H357.664Z",
    fill: "#FED6D6"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M428.193 99.6689H289V254H428.193V99.6689Z",
    fill: "#F1F9FC"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M413.595 69H289V99.6695H428.193V83.5975V69L413.595 69Z",
    fill: "#F1F9FC"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M359.357 215.576H305.612V219.485H359.357V215.576Z",
    fill: "#066F90"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M324.179 221.439H305.612V223.394H324.179V221.439Z",
    fill: "#1698B8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M345.676 227.303H305.612V231.211H345.676V227.303Z",
    fill: "#066F90"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M330.042 233.166H305.612V235.12H330.042V233.166Z",
    fill: "#1698B8"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M377.923 96.3604H356.425V100.269H377.923V96.3604Z",
    fill: "#066F90"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M412.124 106.132H356.425V110.041H412.124V106.132Z",
    fill: "#1698B8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M412.124 121.767H356.425V125.675H412.124V121.767Z",
    fill: "#1698B8"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M412.124 113.949H356.425V117.858H412.124V113.949Z",
    fill: "#1698B8"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M402.352 129.584H356.425V133.493H402.352V129.584Z",
    fill: "#1698B8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M327.11 143.265H305.612V147.173H327.11V143.265Z",
    fill: "#066F90"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M412.124 153.036H305.612V156.945H412.124V153.036Z",
    fill: "#1698B8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M379.877 160.854H305.612V164.762H379.877V160.854Z",
    fill: "#1698B8"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M327.11 172.581H305.612V176.49H327.11V172.581Z",
    fill: "#066F90"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M412.124 182.353H305.612V186.261H412.124V182.353Z",
    fill: "#1698B8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M392.581 197.987H305.612V201.896H392.581V197.987Z",
    fill: "#1698B8"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M412.124 190.17H305.612V194.079H412.124V190.17Z",
    fill: "#1698B8"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M405.283 82.6807H356.425V88.5437H405.283V82.6807Z",
    fill: "#00496F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 305.612,
    y: 135.41,
    width: 52.7305,
    height: 42.9956,
    transform: "rotate(-90 305.612 135.41)",
    fill: "#0383A4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M338.882 123.398V129.966H317.136V123.398C317.136 120.718 318.107 118.238 319.716 116.362C321.726 114.016 324.675 112.542 327.992 112.542C331.008 112.542 333.722 113.748 335.665 115.725C337.676 117.669 338.882 120.383 338.882 123.398Z",
    fill: "#84DAED"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M326.013 120.316C324.439 123.935 323.199 127.152 322.261 129.966H312.912C313.683 126.515 315.157 122.829 317.402 119.076C318.206 117.702 319.01 116.865 319.781 116.362C320.652 115.759 321.49 115.558 322.361 115.424C323.534 115.223 327.689 116.463 326.013 120.316Z",
    fill: "#5BC5DE"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M321.958 102.958C319.244 103.763 316.765 106.678 316.865 109.492C316.966 112.307 320.048 114.15 322.863 114.016C325.678 113.915 329.699 109.492 329.598 106.678C329.464 103.863 325.376 101.92 321.958 102.958Z",
    fill: "#00365D"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M325.947 102.356C328.795 108.052 335.094 110.699 338.579 108.957C342.064 107.215 341.427 101.753 338.579 96.0231C335.731 90.3269 331.442 88.8191 327.957 90.595C324.472 92.3373 323.098 96.6598 325.947 102.356Z",
    fill: "#F1F9FC"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M324.371 105.64C325.041 106.98 327.219 108.019 328.157 107.516C329.095 107.013 328.827 105.841 328.157 104.5C327.487 103.16 326.08 102.322 325.142 102.792C324.17 103.294 323.701 104.299 324.371 105.64Z",
    fill: "#F1F9FC"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M334.224 90.0921C334.19 91.2314 333.989 92.5716 333.62 94.0125C332.883 96.7601 330.705 98.737 328.025 99.7087C327.556 99.8762 327.187 100.312 326.684 101.585C325.21 105.237 322.094 104.266 321.859 105.07L320.653 100.446C320.653 100.446 319.95 95.5873 322.463 92.4376C324.708 89.5895 330.069 86.9759 334.224 90.0921Z",
    fill: "#00365D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M327.99 103.16L334.691 103.562C334.624 104.467 333.954 113.179 333.117 116.362C332.714 117.334 331.006 117.501 329.297 116.798C327.755 116.161 326.75 114.988 326.851 114.084C327.353 112.174 327.822 106.377 327.99 103.16Z",
    fill: "#F1F9FC"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M335.564 88.886C333.721 88.0818 331.376 88.1823 330.639 89.2881C329.901 90.4273 331.242 92.3708 332.951 93.51C334.693 94.6157 338.345 94.5822 339.082 93.4765C339.82 92.3372 337.91 89.8912 335.564 88.886Z",
    fill: "#00365D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M399.251 215.171C392.321 215.171 386.718 220.774 386.718 227.704C386.718 234.634 392.321 240.237 399.251 240.237C406.181 240.237 411.784 234.634 411.784 227.704C411.784 220.774 406.132 215.171 399.251 215.171ZM399.251 238.124C393.5 238.124 388.831 233.455 388.831 227.704C388.831 221.954 393.5 217.284 399.251 217.284C405.002 217.284 409.671 221.954 409.671 227.704C409.671 233.455 405.002 238.124 399.251 238.124Z",
    fill: "#0383A4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M394.385 222.838C391.731 225.492 391.731 229.818 394.385 232.472L404.018 222.838C401.414 220.184 397.088 220.184 394.385 222.838Z",
    fill: "#0383A4"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M404.068 222.839L394.435 232.472C397.089 235.126 401.414 235.126 404.068 232.472C406.722 229.818 406.722 225.542 404.068 222.839Z",
    fill: "#0383A4"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M181.58 317.75C167.001 317.75 154.753 327.489 150.929 340.873H212.232C208.408 327.549 196.1 317.75 181.58 317.75Z",
    fill: "#055C7F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M265.17 317.75C250.591 317.75 238.343 327.489 234.519 340.873H295.822C291.998 327.549 279.749 317.75 265.17 317.75Z",
    fill: "#055C7F"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M225.317 307.892C204.524 307.892 186.958 321.813 181.521 340.874H269.054C263.677 321.813 246.11 307.892 225.317 307.892Z",
    fill: "#055C7F"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M602.578 317.751C588 317.751 575.751 327.49 571.927 340.874H633.23C629.406 327.55 617.157 317.751 602.578 317.751Z",
    fill: "#00496F"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M562.725 307.893C541.932 307.893 524.366 321.814 518.929 340.875H606.462C601.085 321.814 583.518 307.893 562.725 307.893Z",
    fill: "#00496F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M474.182 317.511C474.242 317.451 474.302 317.391 474.361 317.332C474.72 316.794 474.541 316.017 474.003 315.659L466.594 310.998C466.056 310.64 465.279 310.819 464.921 311.357C464.562 311.894 464.742 312.671 465.279 313.03L472.688 317.69C473.166 318.049 473.764 317.929 474.182 317.511Z",
    fill: "#DA9877"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M474.063 315.3C474.063 315.3 476.812 316.914 476.393 317.511C475.915 318.109 468.626 326.175 468.267 325.816C466.893 324.801 471.912 317.272 472.629 316.794C473.286 316.376 473.645 315.061 474.063 315.3Z",
    fill: "#055C7F"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M411.027 223.047C411.027 223.047 405.649 219.821 404.155 220.358C402.662 220.896 407.442 224.541 411.266 224.541L411.027 223.047Z",
    fill: "#DA9877"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M411.803 222.27C411.206 223.107 410.608 223.884 410.011 224.66C422.379 234.34 431.76 235.176 444.726 226.811C446.697 225.557 446.518 224.72 445.263 223.167C445.383 222.808 445.442 222.868 445.263 223.167C444.068 221.613 443.411 221.613 441.439 222.928C428.294 231.412 425.486 229.679 411.803 222.27Z",
    fill: "#F87895"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M438.153 329.461C438.213 329.461 438.332 329.461 438.392 329.461C439.049 329.342 439.468 328.685 439.348 328.027L437.615 319.483C437.496 318.826 436.839 318.408 436.181 318.527C435.524 318.647 435.106 319.304 435.225 319.961L436.958 328.505C437.078 329.103 437.615 329.461 438.153 329.461Z",
    fill: "#DA9877"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M435.465 324.502C436.779 324.442 438.034 324.323 439.348 324.143C435.465 303.53 432.597 275.865 442.874 256.626C439.767 255.072 436.6 253.579 433.433 252.085C425.964 268.875 432.358 306.756 435.465 324.502Z",
    fill: "#055C7F"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M468.925 316.794C469.821 315.779 470.717 314.763 471.554 313.687C448.61 296.24 441.918 282.438 445.742 253.28C442.216 252.742 438.751 252.205 435.226 251.727C435.584 283.992 445.084 296.957 468.925 316.794Z",
    fill: "#055C7F"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M439.707 327.848C439.707 327.848 440.484 330.955 439.707 331.074C438.93 331.134 428.115 331.493 428.056 331.015C427.817 329.282 436.719 327.728 437.556 327.908C438.392 328.087 439.587 327.43 439.707 327.848Z",
    fill: "#055C7F"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M446.1 258.658C444.427 258 441.978 257.343 437.795 257.164C434.927 257.044 432.657 257.164 430.924 257.403C438.333 241.509 439.588 233.622 438.93 229.141C438.572 226.93 439.468 224.66 441.261 223.345L441.978 222.808C445.204 220.298 449.924 222.091 450.701 226.094C450.94 227.408 451.179 228.962 451.239 230.695C451.597 238.88 450.522 247.783 446.1 258.658Z",
    fill: "#FD9CAE"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M447.474 215.936C446.1 219.341 442.575 221.134 440.483 220.297C438.392 219.461 438.512 216.294 439.886 212.888C441.26 209.483 443.65 208.407 445.741 209.303C447.833 210.2 448.848 212.53 447.474 215.936Z",
    fill: "#DA9877"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M448.55 217.729C448.251 218.506 447.056 219.223 446.458 218.984C445.861 218.745 445.98 218.028 446.339 217.251C446.638 216.474 447.414 215.877 448.012 216.116C448.55 216.355 448.848 216.952 448.55 217.729Z",
    fill: "#DA9877"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M448.848 213.965C448.848 213.965 449.028 211.515 447.653 210.021C446.279 208.527 442.933 207.332 440.961 210.081C440.961 210.081 439.766 212.172 442.395 213.367C445.024 214.622 445.024 213.009 445.861 214.801C446.757 216.594 448.311 215.996 448.43 216.355L448.848 213.965Z",
    fill: "#582105"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M446.876 216.056L443.052 215.697C442.993 216.235 442.574 221.254 442.813 223.106C442.933 223.704 443.889 223.943 444.964 223.704C445.92 223.465 446.578 222.927 446.578 222.389C446.458 221.254 446.697 217.908 446.876 216.056Z",
    fill: "#DA9877"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M445.802 217.31C445.144 216.832 444.726 217.43 443.531 218.445C442.336 219.461 439.886 219.7 439.11 216.593C438.632 214.621 438.094 218.087 438.094 218.087C438.153 219.76 438.811 220.656 440.065 221.194C441.798 221.911 444.188 221.254 446.04 219.581C446.279 218.804 446.28 217.669 445.802 217.31Z",
    fill: "#582105"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M438.989 216.534C438.989 216.534 439.049 216.534 439.109 216.594C439.826 216.833 443.172 217.908 443.709 219.103C444.307 220.418 441.977 218.864 441.26 218.088C440.543 217.311 439.826 217.55 439.109 217.49C438.451 217.43 438.033 216.713 438.989 216.534Z",
    fill: "#582105"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M428.354 246.828C428.354 246.828 422.559 243.721 421.005 244.319C419.452 244.976 424.65 248.561 428.653 248.382L428.354 246.828Z",
    fill: "#DA9877"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M427.518 246.23C427.04 247.365 426.622 248.441 426.084 249.516C446.638 250.95 451.896 246.708 450.522 227.707C450.283 224.78 449.685 224.481 447.176 225.138C445.323 225.616 445.383 226.692 445.562 229.261C447.116 246.23 446.22 245.214 427.518 246.23Z",
    fill: "#F87895"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M411.557 247.513L416.283 245.654L394.268 189.662L389.541 191.52L411.557 247.513Z",
    fill: "#292B3B"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M410.669 249.522L418.287 246.526L402.306 205.88L394.688 208.875L410.669 249.522Z",
    fill: "#00496F"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M350.738 174.052C357.251 190.602 375.953 198.788 392.504 192.275C409.054 185.763 417.24 167.061 410.727 150.51C404.215 133.959 385.513 125.774 368.962 132.286C352.352 138.739 344.226 157.441 350.738 174.052ZM353.427 172.976C347.512 157.919 354.921 140.89 369.978 134.975C385.035 129.06 402.064 136.469 407.979 151.526C413.894 166.583 406.485 183.612 391.428 189.527C376.371 195.442 359.342 188.033 353.427 172.976Z",
    fill: "#292B3B"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M409.456 167.963C412.632 152.074 402.326 136.62 386.438 133.444C370.55 130.269 355.096 140.574 351.92 156.462C348.744 172.351 359.05 187.805 374.938 190.981C390.826 194.156 406.281 183.851 409.456 167.963Z",
    fill: "#EBECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.bc9baf1f0f5253a5a750c69857d59fbb.svg";
export { ForwardRef as ReactComponent };